import { useEffect, useState } from 'react';
import axios from 'axios';

export function Services() {
    const [servicesData, setServicesData] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/services`)
            .then(response => {
                setServicesData(response.data);
            })
            .catch(error => {
                console.error('Error fetching services data:', error);
            });
    }, []);

    if (!servicesData) {
        return <div id="services">Loading...</div>;
    }

    return (
        <div id="services" className="container-xxl py-5 section">
            <div className="container">
                <div className="row g-5">
                    <div className="col-lg-7 wow fadeInUp" data-wow-delay="0.1s">
                        <h2 className="text-secondary text-uppercase">{servicesData.title}</h2>
                        {servicesData.sections.map((section, index) => (
                            <div key={index}>
                                <h3 className="mb-4">{section.sectionTitle}</h3>
                                <p className="mb-4">{section.sectionContent}</p>
                            </div>
                        ))}
                    </div>
                    <div className="col-lg-5 pt-4">
                        <div className="position-relative h-100 wow fadeInUp" data-wow-delay="0.5s">
                            <img className="position-absolute start-0 bottom-0 img-fluid" style={{ maxHeight: '100%' }} src={process.env.REACT_APP_API_BASE_URL + "/" + servicesData.pictureUrl} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}